import {init as initAmplitude} from '@amplitude/analytics-browser'
import {amplitudeDev, amplitudeProd} from '@helpers/events/config'
import logger from '@helpers/logger'
import getEnv from '@providers/getEnv'

export default function init() {
  const amplitudeApiKey = getEnv() === 'prod' ? amplitudeProd : amplitudeDev
  try {
    initAmplitude(amplitudeApiKey)
  } catch (e) {
    logger.error(e)
  }
}
